import { createContext, useContext, useState, ReactNode } from "react";

type Modo = "dark" | "light";

interface ContextData {
  modo: Modo;
  toggleTema: () => void;
}

const ThemeContext = createContext<ContextData>({} as ContextData);

export function useThemeMode() {
  return useContext(ThemeContext);
}

export function ThemeModeProvider({ children }: { children: ReactNode }) {
  const [modo, setModo] = useState<Modo>(() => {
    return (localStorage.getItem("@tema") as Modo) ?? "light";
  });

  function toggleTema() {
    setModo((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem("@tema", next);
      return next;
    });
  }

  return (
    <ThemeContext.Provider value={{ modo, toggleTema }}>
      {children}
    </ThemeContext.Provider>
  );
}
